/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetOrderReportDetailsQuery } from '../../models/get-order-report-details-query';
import { GetOrderReportDetailsQueryResult } from '../../models/get-order-report-details-query-result';

export interface ApiNurseryManagerReportsGetOrdersStakeholderDetailsReportPost$Params {
      body?: GetOrderReportDetailsQuery
}

export function apiNurseryManagerReportsGetOrdersStakeholderDetailsReportPost(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerReportsGetOrdersStakeholderDetailsReportPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetOrderReportDetailsQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerReportsGetOrdersStakeholderDetailsReportPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetOrderReportDetailsQueryResult>;
    })
  );
}

apiNurseryManagerReportsGetOrdersStakeholderDetailsReportPost.PATH = '/api/NurseryManager/Reports/GetOrdersStakeholderDetailsReport';
